import { BranchItemFragment, OpeningTimeServiceType } from '@app/graphql/types/graphql.ts';
import Card from '@app/components/card/card.tsx';
import CardContent from '@app/components/card/card-content.tsx';
import CDNLink from '@app/utils/cdn-link.ts';
import { todayIs } from '@app/page/online-order/product-picker/utils/today';
import { useTranslate } from '@tolgee/react';

export default function AppointmentBusinessCard(props: { branch: BranchItemFragment }) {
  const today = todayIs();
  const { t } = useTranslate();

  const todayOpeingTime = props.branch.openingTimes?.filter(
    (item) => item.dayOfWeek == today && item.service == OpeningTimeServiceType.Appointment
  );

  return (
    <Card className="z-10 shadow-md sm:relative">
      {props.branch.company.hubPage?.banner && (
        <div
          style={{
            backgroundImage: `url(${import.meta.env.VITE_CDN_HOST as string}/${props.branch.company.hubPage.banner ?? ''})`,
          }}
          className="hidden h-48 w-full bg-cover bg-center bg-no-repeat xl:block"
        ></div>
      )}
      <CardContent>
        <div className="flex flex-col space-y-4">
          <div className="grow space-y-6">
            <div className="flex items-start justify-between gap-x-4">
              <div className="flex items-center gap-x-3">
                {props.branch.company.logo && (
                  <img
                    className="w-24 rounded-md"
                    src={CDNLink(props.branch.company.logo)}
                    alt={props.branch.company.name}
                  />
                )}
                <div className="space-y-1">
                  <p className="pt-2 text-xl font-medium">{props.branch.company.name}</p>
                  <p className="flex flex-wrap gap-x-1 text-sm text-gray-600">
                    <span>{props.branch.streetAddress},</span>
                    <span>{props.branch.postalCode}</span>
                    <span>
                      {props.branch.addressLocality}
                      {props.branch.addressCountry && <>,</>}{' '}
                    </span>
                    <span>{props.branch.addressCountry}</span>
                  </p>

                  {todayOpeingTime && todayOpeingTime.length > 0 && (
                    <div className="flex items-center gap-x-1 text-sm text-gray-500">
                      <span>{t('appointment.business-card.opening', 'Opening time')}:</span>
                      {todayOpeingTime.map((item, index) => (
                        <p key={index}>
                          {item.openTime} - {item.closeTime}
                          {index < todayOpeingTime.length - 1 && <span>,</span>}
                        </p>
                      ))}
                    </div>
                  )}

                  {props.branch.website && <p className="mt-2 text-sm text-gray-600">{props.branch.website}</p>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
